import { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';

import './scss/app.css';
import './scss/style.css';

import {
    PageLoadingComponent,
} from "./component/base";

const loading = () => <div className="animated fadeIn pt-3 text-center">
  <PageLoadingComponent isLoading={true} />
</div>;

// Containers
const DefaultLayout = lazy(() => import('./containers/DefaultLayout'));
const UserLogin = lazy(() => import('./out/site/UserLogin'));
const UserRegister = lazy(() => import('./out/site/UserRegister'));
const OopsPage = lazy(() => import('./out/site/OopsPage'));

(function fetchUserDetails() {
  const storedIp = localStorage.getItem("userIp");
  if (!storedIp) {
      const xhr = new XMLHttpRequest();
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        xhr.open("GET", "http://ip-api.com/json/", false); // Synchronous request
      }else{
        xhr.open("GET", "https://ip-api.com/json/", false); // Synchronous request
      }
      xhr.send(null);

      if (xhr.status === 200) {
          const data = JSON.parse(xhr.responseText);
          localStorage.setItem("userIp", data.query || "");
          localStorage.setItem("country", data.country || "");
          localStorage.setItem("regionName", data.regionName || "");
          localStorage.setItem("city", data.city || "");
          localStorage.setItem("zipcode", data.zip || "");
          localStorage.setItem("latitude", data.lat || "0");
          localStorage.setItem("longitude", data.lon || "0");
          localStorage.setItem("timezone", data.timezone || "Asia/Kolkata");
      }
  }
})();



function App() {

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    
    const blockContextMenu = (e) => e.preventDefault();
    const blockTextSelect = (e) => e.preventDefault();
  
    const blockKeys = (e) => {
      const blockedKeys = [
        "F12",
        "Control+Shift+I",
        "Control+Shift+J",
        "Control+Shift+C",
        "Control+U",
        "Control+S",
      ];
      const keyCombo =
        (e.ctrlKey ? "Control+" : "") +
        (e.shiftKey ? "Shift+" : "") +
        (e.key.length === 1 ? e.key.toUpperCase() : e.key);
  
      if (blockedKeys.includes(keyCombo)) {
        e.preventDefault();
      }
    };
  
    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("selectstart", blockTextSelect);
    document.addEventListener("keydown", blockKeys);
  
    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("selectstart", blockTextSelect);
      document.removeEventListener("keydown", blockKeys);
    };
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={loading()}>
        <Routes>
          <Route path="/" element={<UserLogin />} />
          <Route path="/UserLogin" element={<UserLogin />} />
          <Route path="/UserRegister" element={<UserRegister />} />
          <Route exact path="/Oops" name="Oops" home='/DevelopingScreen' element={<OopsPage />} />
          <Route path="/*" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
